module.exports = __webpack_public_path__ + "img/card-small-b6.ba3dc4cd.png";